const VIDEO_PORTALS = {
  YOUTUBE: 'youtube',
  VK: 'vkvideo',
  RUTUBE: 'rutube',
};

const generateUrl = function (id, portalId) {
  const query = '?rel=0&enablejsapi=1';
  let url;
  let parts;

  if (portalId === VIDEO_PORTALS.YOUTUBE) {
    url = 'https://www.youtube.com/embed/' + id + query;
  } else if (portalId === VIDEO_PORTALS.VK) {
    parts = id.split('_');
    url = 'https://vk.com/video_ext.php?oid=' + parts[0] + '&id=' + parts[1] + query;
  } else if (portalId === VIDEO_PORTALS.RUTUBE) {
    url = 'https://rutube.ru/play/embed/' + id + query;
  }

  return url;
};

const createIframe = function (id, portalId) {
  const iframe = document.createElement('iframe');

  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('src', generateUrl(id, portalId));

  return iframe;
};

const createPreview = function (previewSrc) {
  const li = document.createElement('li');
  li.setAttribute('class', 'slider-tns__thumbnails-item');

  const image = document.createElement('image');
  image.setAttribute('src', previewSrc);
  image.setAttribute('width', '120');
  image.setAttribute('height', '90');

  li.append(image);
  return li;
};

const uploadPreview = function () {
  const sliderPreviews = document.getElementById('video-previews');
  const videos = document.querySelectorAll('[data-video]');

  videos.forEach((el) => {
    const previewSrc = el.getAttribute('data-thumbnail-url');

    const preview = createPreview(previewSrc);
    sliderPreviews.append(preview);
  });
  sliderPreviews.style.margin = '0 60px 0 70px';
};
const uploadVideos = function () {
  const videos = document.querySelectorAll('[data-video]');

  videos.forEach((el) => {
    const videoId = el.getAttribute('data-video');
    const portalId = el.getAttribute('data-portal');

    const iframe = createIframe(videoId, portalId);

    const videoWrapper = el.getElementsByClassName('popup-slider-item__video-wrapper');

    if (videoWrapper.length === 0) {
      el.append(iframe);
    } else {
      videoWrapper[0].append(iframe);
    }

    el.removeAttribute('data-video');
  });
};
export { uploadPreview, uploadVideos };
